export const usecaseAIList = ["welcomeAi"];
